module.exports = __webpack_public_path__ + "static/media/hollow-cut-youtube.d4c384bd.svg";